// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3kHUJ","log":"ModalInventoryLogs_log__23B7Q","date":"ModalInventoryLogs_date__2V3dW","userName":"ModalInventoryLogs_userName__4yLgp"};